import SkillItem from './SkillItem.jsx';

export default SkillItem;
